(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var loginPanel = document.getElementById('mg-customer-login-form');
    var recoverPanel = document.getElementById('mg-customer-recover-form');
    if (!loginPanel || !recoverPanel) return;

    function showRecover() {
      loginPanel.hidden = true;
      recoverPanel.hidden = false;
    }

    function showLogin() {
      recoverPanel.hidden = true;
      loginPanel.hidden = false;
    }

    var recoverBtns = document.querySelectorAll('[data-toggle-recover]');
    var loginBtns = document.querySelectorAll('[data-toggle-login]');

    recoverBtns.forEach(function (btn) { btn.addEventListener('click', showRecover); });
    loginBtns.forEach(function (btn) { btn.addEventListener('click', showLogin); });

    if (window.location.hash === '#recover') {
      showRecover();
    }
  });
})();
